
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';

import {customlistadodeestudiosrvquh_69745c44a85c3d434df35756 } from '../../api/publicacindeestudior78or.api'

import './aboutus.scss';








const Paboutus = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {

	const [loftyres_69745c44a85c3d434df35756_component_iz67p, setloftyres_69745c44a85c3d434df35756_component_iz67p] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customlistadodeestudiosrvquh_69745c44a85c3d434df35756({
				});
				setloftyres_69745c44a85c3d434df35756_component_iz67p(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);



  
  
  
  

  
  return (
    <div id="id68c4936a8e5aed52dc7e10a4" >

      <div id="i9ol" className="">
      
      <div id="icjbu5" className="">
      
        <a
          target=""
          className=""
          id="i88pyl"
          href={`/`}
        >
          
      <img
        className=""
        id="iwbvf5"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfhcxkni.png"
        alt="undefined"
      />
      
        </a>
        
      </div>
      
      <div id="ipwig4" className="">
      
        <a
          target=""
          className=""
          id="ikgeum"
          href="/estudios"
        >
          
    <div id="i2kn3s" className="">
    <>Estudios</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ivw47x"
          href={`/contact`}
        >
          
    <div id="iv1mlt" className="">
    <>Contacto</>
    </div>
    
        </a>
        
      </div>
      
      </div>
      
      <div id="iizt" className="">
      
      <div id="iwdy" className="">
      
      <div className="" id="i1hzn">
        <>Sobre Nosotros</>
      </div>
      
      <div className="" id="i32i8">
        <>M2Global Insights lleva a cabo encuestas representativas a nivel   </>
      <br className="" id="" />
      <>nacional con su tecnología de recolección de datos y técnicas de   </>
      <br className="" id="" />
      <>ajuste de resultados para garantizar la precisión de la muestra.  </>
      </div>
      
      </div>
      
      </div>
      
      <div id="ifgm" className="">
      
      <div id="i7k3wa" className="">
      
      <div className="" id="iv3a9g">
        <>Nuestro Equipo</>
      </div>
      
      </div>
      
      <div id="isfsn" className="">
      
      <div id="imvl9" className="">
      
      <div id="iq7hx8" className="">
      
      <img
        className=""
        id="iypzp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfhd6w50.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="icwgn">
        <>Carlos G. Calix</>
      </div>
      
      <div className="" id="igyzq">
        <>Director Ejecutivo  </>
      </div>
      
      </div>
      
      <div id="i0d0rh" className="">
      
      <div id="i1hbdi" className="">
      
      <img
        className=""
        id="izpj15"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfhd6w50.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="i3llc3">
        <>Daniel</>
      </div>
      
      <div className="" id="icaev9">
        <>Director de Tecnología    </>
      </div>
      
      </div>
      
      <div id="ihbotf" className="">
      
      <div id="ig9a5m" className="">
      
      <img
        className=""
        id="iiuoaq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfhd6w50.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="ipc844">
        <>Marcela Barahona</>
      </div>
      
      <div className="" id="imiyfq">
        <>Socia Directora,   </>
      <br className="" id="" />
      <>Centroamérica.  </>
      </div>
      
      </div>
      
      <div id="ii0khg" className="">
      
      <div id="izq9jq" className="">
      
      <img
        className=""
        id="i9uq54"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfhd6w50.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iuc4q7">
        <>Fernanda Armagno</>
      </div>
      
      <div className="" id="i419a3">
        <>Analista de datos y   </>
      <br className="" id="" />
      <>Jefe de políticas públicas.  </>
      </div>
      
      </div>
      
      <div id="ilakjp" className="">
      
      <div id="ilfo9f" className="">
      
      <img
        className=""
        id="i6zlpf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimfhd6w50.png"
        alt="undefined"
      />
      
      </div>
      
      <div className="" id="iag5h8">
        <>Arles Cerrato</>
      </div>
      
      <div className="" id="i8o5eo">
        <>Ingeniero Jefe de   </>
      <br className="" id="" />
      <>Software</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ifgm-2" className="">
      
      <div id="irers" className="">
      
        <a
          target=""
          className=""
          id="iuuhyl"
          href="#"
        >
          
      <span className="" id="iy1fm9">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <div id="ihdlf" className="">
      
      <div className="" id="iekiw">
        <>Nuestros Estudios</>
      </div>
      
      </div>
      
        <div id="iz67p" className="">
        
            {
              loftyres_69745c44a85c3d434df35756_component_iz67p.map((loftyitem_69745c44a85c3d434df35756_component_iz67p) => (
                <div key={loftyitem_69745c44a85c3d434df35756_component_iz67p._id} className="" id="is4qc">
                  
      <div id="i2fcg" className="">
      
      <div id="igldc" className="">
      
        <img
          className=""
          id="iyqub"
          alt=""
          src={loftyitem_69745c44a85c3d434df35756_component_iz67p.loftyUrl}
        />
        
      </div>
      
        <a
          target=""
          className=""
          id="isot6"
          href={`/estudios/${loftyitem_69745c44a85c3d434df35756_component_iz67p._id}`}
        >
          
        <div className="" id="il90d">
          
          <div className="" id="iuilj">
            {loftyitem_69745c44a85c3d434df35756_component_iz67p?.pas7z0bn}
          </div>
          
        </div>
        
        <div className="" id="ievdq">
          
          <div className="" id="">
            {loftyitem_69745c44a85c3d434df35756_component_iz67p?.titulo2lvs3}
          </div>
          
        </div>
        
        <div className="" id="i8lej">
          
          <div className="" id="">
            {loftyitem_69745c44a85c3d434df35756_component_iz67p?.descripcincortav6uva}
          </div>
          
        </div>
        
        </a>
        
      </div>
      
                </div>
              ))
            }
            
        </div>
        
      </div>
      
      <div id="ii5t" className="">
      
      <div id="io6yi" className="">
      
      </div>
      
      <div id="iyvwk" className="">
      
      <div id="ivlb5" className="">
      
      <div id="iw4hc" className="">
      
      <div className="" id="i3df7">
        <>Seguimiento profesional</>
      </div>
      
      <div className="" id="i6pj8">
        <>Encuestas de alta frecuencia patentadas que le permiten ser el primero en saber cuándo cambia la opinión pública y la probabilidad de resultados políticos.</>
      </div>
      
        <a
          target=""
          className=""
          id="i3aw6g"
          href="#"
        >
          
      <span className="" id="iifyiy">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="iuyzc2"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="imwvvh" className="">
      
      <div id="iv9sr1" className="">
      
      <div className="" id="iin1ty">
        <>M2Global Monitor  </>
      </div>
      
      <div className="" id="ibz2nf">
        <>M2Global es una herramienta de inteligencia de redes sociales personalizable que proporciona un monitoreo granular de empresas, organizaciones, temas, campañas políticas, etc.</>
      </div>
      
        <a
          target=""
          className=""
          id="i00gff"
          href="#"
        >
          
      <span className="" id="id3vz7">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="icj4qn"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="inx1hy" className="">
      
      <div id="ijerzc" className="">
      
      <div className="" id="i8jk4i">
        <>Encuestas Públicas</>
      </div>
      
      <div className="" id="iu6t0x">
        <>Encuestas representativas a nivel nacional realizadas por M2Global   utilizando su tecnología patentada de recopilación de datos y algoritmos de post-estratificación.</>
      </div>
      
        <a
          target=""
          className=""
          id="in1c0v"
          href="#"
        >
          
      <span className="" id="iq2lzm">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="iif51w"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="itkdrg" className="">
      
      <div id="icg789" className="">
      
      <div className="" id="i8sspp">
        <>M2Global Político   </>
      </div>
      
      <div className="" id="ixdzez">
        <>M2Global Político    es una plataforma de transparencia política que empodera a los ciudadanos para exigir cuentas a sus políticos.</>
      </div>
      
        <a
          target=""
          className=""
          id="ilx2im"
          href="#"
        >
          
      <span className="" id="i5r0b4">
        <>Ver Mas</>
      </span>
      
        </a>
        
      </div>
      
      <img
        className=""
        id="idv40l"
        src="https://assetsprojects.s3.amazonaws.com/404pziime7ox3y3.jpg"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      <div id="id4e2" className="">
      
      <div className="" id="iglijz">
        <>Copyright © 2025 M2GlobalInsigths ORG</>
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Paboutus);
  